import ReactGA from 'react-ga4';

import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    editIconContainer: {
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    editPosition: {
        position: 'absolute'
    },
    editIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#FFFFFF',
        border: 'none',
        borderRadius: 40,
        boxShadow: '0px 8px 16px 4px rgba(0, 0, 0, 0.05)',
        color: '#2B3165',
        fontSize: '1.2rem',
        minHeight: '48px !important',
        minWidth: '48px !important',
        outline: 'none'
    },
    saveBtn: {
        backgroundColor: '#7378E8',
        borderRadius: '40px',
        color: '#FFFFFF',
        fontSize: '12px',
        fontWeight: 800,
        textTransform: 'none',
        padding: '6px 12px'
    }
}));

type EditIconProps = {
    edit?: boolean;
    setEdit: (edit: boolean) => void;
    handleImageClick?: () => void;
    handleSave?: () => void;
    picturePosition?: { bottom?: string; top?: string; right: string };
    newProfilePicture?: File | null;
    pencilAriaLabel?: string;
    saveAriaLabel?: string;
};

const EditIcon: React.FC<EditIconProps> = ({
    edit,
    setEdit,
    handleImageClick,
    handleSave,
    picturePosition,
    newProfilePicture,
    pencilAriaLabel,
    saveAriaLabel
}) => {
    const classes = useStyles();

    const renderClasses = () => {
        if (!edit && !newProfilePicture) {
            return `${classes.editPosition} ${classes.editIconContainer}`;
        } else {
            return classes.editIconContainer;
        }
    };

    const handleEdit = () => {
        if (handleImageClick) {
            ReactGA.event({
                category: 'Holder Profile',
                action: 'Edit Profile Picture'
            });

            handleImageClick();
        } else {
            ReactGA.event({
                category: 'Holder Profile',
                action: 'Edit Profile Name'
            });

            setEdit(true);
        }
    };

    const handleSaveChanges = () => {
        if (handleSave) {
            handleSave();
        }
        setEdit(false);
    };

    return (
        <div
            className={renderClasses()}
            style={
                picturePosition
                    ? picturePosition
                    : { right: '-40px', top: '-16px' }
            }
        >
            {!edit ? (
                <Button
                    className={classes.editIcon}
                    onClick={() => handleEdit()}
                    aria-label={pencilAriaLabel || "Edit"}
                >
                    <i className="far fa-pencil" />
                </Button>
            ) : (
                <Button
                    className={classes.saveBtn}
                    onClick={() => handleSaveChanges()}
                    aria-label={saveAriaLabel || "Save"}
                >
                    Save
                </Button>
            )}
        </div>
    );
};

export default EditIcon;
